import { render, staticRenderFns } from "./ComboMotivoLead.vue?vue&type=template&id=505808c0"
import script from "./ComboMotivoLead.vue?vue&type=script&lang=ts"
export * from "./ComboMotivoLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports